import { PRODUCT_DIGITAL_FILE_UUID, PRODUCT_DIGITAL_GROUP_FILE_UUID, PRODUCT_DIGITAL_GROUP_SET_UUID, PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID, PRODUCT_DIGITAL_MINI_GROUP_SET_UUID, PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_FILE_UUID, PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_SET_UUID, PRODUCT_DIGITAL_SET_UUID, } from "@/react/Webshop/providers/PriceListProvider";
export const hasPortraitSiblingProduct = (priceList) => !!priceList.getProductByUuid(PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_FILE_UUID);
/*
export const getFilteredPicturesByType = (
  pictures: PictureSetPicture[],
  type: string,
  { excludeBought = true, excludeSetBought = false } = {},
) =>
  pictures.filter(
    (picture) =>
      picture.pictureType === type &&
      (!excludeBought || !picture.bought) &&
      (!excludeSetBought || !picture.setBought),
  );

export const getIndividualAndSiblingPictures = (sortedPictures, bought) =>
  sortedPictures.filter(
    (picture) =>
      ["IP", "SFP"].includes(picture.pictureType) &&
      !picture.bought &&
      !bought,
  );
*/
export const PICTURE_TYPES = ["IP", "SFP", "GP"];
export const getUuidMap = (portraitSiblingProductAvailable, t) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const baseMap = {
        IP: {
            singleFile: PRODUCT_DIGITAL_FILE_UUID,
            pictureSet: PRODUCT_DIGITAL_SET_UUID,
            title: t("Individual pictures"),
            fileFilter: (picture) => picture.pictureType === "IP",
            getSetIsBought: (ps) => ps.digitalSet["IP"].bought,
            getSetIsInCart: (ps) => ps.digitalSet["IP"].inCart,
            orderLineSingleFileText: (_a = t("%d x portrait file")) !== null && _a !== void 0 ? _a : "",
            orderLineSetText: (_b = t("%d x portrait set")) !== null && _b !== void 0 ? _b : "",
        },
        SFP: {
            singleFile: PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID,
            pictureSet: PRODUCT_DIGITAL_MINI_GROUP_SET_UUID,
            title: t("Sibling & friends pictures"),
            fileFilter: (picture) => picture.pictureType === "SFP",
            getSetIsBought: (ps) => ps.digitalSet["SFP"].bought,
            getSetIsInCart: (ps) => ps.digitalSet["SFP"].inCart,
            orderLineSingleFileText: (_c = t("%d x sibling and friend file")) !== null && _c !== void 0 ? _c : "",
            orderLineSetText: (_d = t("%d x sibling and friend set")) !== null && _d !== void 0 ? _d : "",
        },
        GP: {
            singleFile: PRODUCT_DIGITAL_GROUP_FILE_UUID,
            pictureSet: PRODUCT_DIGITAL_GROUP_SET_UUID,
            title: t("Group pictures"),
            fileFilter: (picture) => picture.pictureType === "GP",
            getSetIsBought: (ps) => ps.digitalSet["GP"].bought,
            getSetIsInCart: (ps) => ps.digitalSet["GP"].inCart,
            orderLineSingleFileText: (_e = t("%d x group picture")) !== null && _e !== void 0 ? _e : "",
            orderLineSetText: (_f = t("%d x group set")) !== null && _f !== void 0 ? _f : "",
        },
    };
    if (!portraitSiblingProductAvailable) {
        return baseMap;
    }
    // Override IP and SFP for portrait-sibling bundle
    const overrideEntryIP = {
        singleFile: PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_FILE_UUID,
        pictureSet: PRODUCT_DIGITAL_PORTRAIT_IP_SIBLING_AND_FRIEND_SET_UUID,
        title: t("Individual and friend pictures"),
        fileFilter: (picture) => ["IP", "SFP"].includes(picture.pictureType),
        getSetIsBought: (ps) => ps.digitalSet["IP"].bought,
        getSetIsInCart: (ps) => ps.digitalSet["IP"].inCart,
        orderLineSingleFileText: (_g = t("%d x portrait file")) !== null && _g !== void 0 ? _g : "",
        orderLineSetText: (_h = t("%d x portrait set")) !== null && _h !== void 0 ? _h : "",
    };
    // Dummy which should never return any pictures
    const overrideEntrySFP = {
        singleFile: PRODUCT_DIGITAL_MINI_GROUP_FILE_UUID,
        pictureSet: PRODUCT_DIGITAL_MINI_GROUP_SET_UUID,
        title: t("Sibling & friends pictures"),
        fileFilter: (picture) => false,
        getSetIsBought: (ps) => ps.digitalSet["SFP"].bought,
        getSetIsInCart: (ps) => ps.digitalSet["SFP"].inCart,
        orderLineSingleFileText: (_j = t("%d x portrait file")) !== null && _j !== void 0 ? _j : "",
        orderLineSetText: (_k = t("%d x portrait set")) !== null && _k !== void 0 ? _k : "",
    };
    return {
        IP: overrideEntryIP,
        SFP: overrideEntrySFP,
        GP: baseMap.GP,
    };
};
export const getNotBoughtPictures = (pictureSet, settings) => {
    if (settings.getSetIsBought(pictureSet)) {
        return [];
    }
    return pictureSet.pictures.filter((p) => !p.bought && settings.fileFilter(p));
};
export const getBoughtPicturesByType = (pictureSet, settings) => {
    if (settings.getSetIsBought(pictureSet)) {
        return pictureSet.pictures.filter((p) => settings.fileFilter(p));
    }
    return pictureSet.pictures.filter((p) => p.bought && settings.fileFilter(p));
};
export const getAllBoughtPictures = (pictureSet, priceList, t) => {
    const settings = getUuidMap(hasPortraitSiblingProduct(priceList), t);
    let boughtPictures = [];
    for (const type of getPictureTypes()) {
        boughtPictures = boughtPictures.concat(getBoughtPicturesByType(pictureSet, settings[type]));
    }
    return boughtPictures;
};
export const getPicturesAvailableToBeBought = (pictureSet, priceList, t) => {
    const settings = getUuidMap(hasPortraitSiblingProduct(priceList), t);
    let pictures = [];
    for (const type of getPictureTypes()) {
        const fileProduct = getProductForType(priceList, settings[type], "singleFile");
        const setProduct = getProductForType(priceList, settings[type], "pictureSet");
        if (!fileProduct && !setProduct) {
            continue;
        }
        const picturesOfType = getNotBoughtPictures(pictureSet, settings[type]);
        pictures = pictures.concat(picturesOfType);
    }
    return pictures;
};
export const priceListHaveDigitalPictureProducts = (priceList, t) => {
    const settings = getUuidMap(hasPortraitSiblingProduct(priceList), t);
    const types = ["IP", "SFP", "GP"];
    for (const type of types) {
        if (getProductForType(priceList, settings[type], "singleFile")) {
            return true;
        }
        if (getProductForType(priceList, settings[type], "pictureSet")) {
            return true;
        }
    }
    return false;
};
export const getPictureTypes = () => {
    const types = ["IP", "SFP", "GP"];
    return types;
};
export const getProductForType = (priceList, settings, productType) => {
    var _a;
    return (_a = priceList.getProductByUuid(settings[productType])) !== null && _a !== void 0 ? _a : null;
};
export const getTotalPicturesInCartByType = (settings, pictureSets) => {
    const allPictures = [];
    for (const pictureSet of pictureSets) {
        const pictures = getNotBoughtPictures(pictureSet, settings).filter((p) => p.inCart);
        for (const picture of pictures) {
            if (!allPictures.includes(picture)) {
                allPictures.push(picture);
            }
        }
    }
    return allPictures;
};
/*
export const calculatePrices = (
  priceList,
  uuidMap,
  digitalFileRebatedPrice,
  digitalSetRebatedPrice,
  pictureType,
) => {
  const singleFileProduct = getProductForType(
    priceList,
    uuidMap,
    pictureType,
    "singleFile",
  );
  const pictureSetProduct = getProductForType(
    priceList,
    uuidMap,
    pictureType,
    "pictureSet",
  );

  const singleFilePrice = singleFileProduct?.productprices[0]?.price || null;
  const singleFileRebatedPrice =
    digitalFileRebatedPrice >= 0 && digitalFileRebatedPrice < singleFilePrice
      ? digitalFileRebatedPrice
      : null;

  const pictureSetPrice = pictureSetProduct?.productprices[0]?.price || null;
  const pictureSetRebatedPrice =
    digitalSetRebatedPrice >= 0 && digitalSetRebatedPrice < pictureSetPrice
      ? digitalSetRebatedPrice
      : null;

  return {
    singleFilePrice,
    singleFileRebatedPrice,
    pictureSetPrice,
    pictureSetRebatedPrice,
  };
};
*/
export const canPictureSetBeBought = (pictureSet, priceList, t) => {
    const portraitSiblingProductAvailable = hasPortraitSiblingProduct(priceList);
    const uuidMap = getUuidMap(portraitSiblingProductAvailable, t);
    const types = ["IP", "SFP", "GP"];
    for (const type of types) {
        const settings = uuidMap[type];
        const pictures = getNotBoughtPictures(pictureSet, settings);
        if (pictures.length === 0) {
            continue;
        }
        if (getProductForType(priceList, settings, "singleFile")) {
            return true;
        }
        if (getProductForType(priceList, settings, "pictureSet")) {
            return true;
        }
    }
    return false;
};
export const getPictureIsBought = (picture, pictureSet, priceList) => {
    if (picture.bought) {
        return true;
    }
    if (hasPortraitSiblingProduct(priceList)) {
        if ((picture.pictureType === "IP" || picture.pictureType === "SFP") &&
            pictureSet.digitalSet.IP.bought) {
            return true;
        }
        else if (picture.pictureType === "GP" &&
            pictureSet.digitalSet.GP.bought) {
            return true;
        }
    }
    else {
        if (picture.pictureType === "IP" && pictureSet.digitalSet.IP.bought) {
            return true;
        }
        else if (picture.pictureType === "SFP" &&
            pictureSet.digitalSet.SFP.bought) {
            return true;
        }
        else if (picture.pictureType === "GP" &&
            pictureSet.digitalSet.GP.bought) {
            return true;
        }
    }
    return false;
};
export const getFileProductByPicture = (picture, priceList, t) => {
    const settings = getUuidMap(hasPortraitSiblingProduct(priceList), t);
    const types = ["IP", "SFP", "GP"];
    for (const type of types) {
        if (settings[type].fileFilter(picture)) {
            return getProductForType(priceList, settings[type], "singleFile");
        }
    }
    return null;
};
export const getComputedPictureType = (picture, priceList, t) => {
    const settings = getUuidMap(hasPortraitSiblingProduct(priceList), t);
    const types = ["IP", "SFP", "GP"];
    for (const type of types) {
        if (settings[type].fileFilter(picture)) {
            return type;
        }
    }
    return null;
};
